// import { route } from 'ziggy-js'
import { router } from "@inertiajs/vue3";
import { useRouter } from "@/helpers/composables/useRouter";
import { useFetch } from "@/helpers/composables/useFetch";
import { useSettingsStore } from "@/store/settings";
import NProgress from "nprogress";
import { inject, ref } from "vue";
export function useAddressBook(){
    let route = inject('route');
    const { to } = useRouter({
        router, route
    });

    const { setNotificationMessage } = useSettingsStore();
    const isLoading = ref(false);

    const createAddress = (customer_address, { afterFetch }) => {
        const { data } = useFetch(route("endpoint.customeraddress.store"), {
            beforeFetch: (ctx) => {
                let { cancel } = ctx;
                if(isLoading.value){
                    cancel();
                }
                NProgress.start();
                isLoading.value = true;
                ctx.options.headers = {
                    ...ctx.options.headers,
                    'Accept': 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Address added successfully"
                });
                isLoading.value = false;
            },
            onFetchError: ()=>{
                isLoading.value = false;
            }
        })
            .post({
                customer_address
            })
            .json();
        return data;
    };

    const updateAddress = (customer_address, { afterFetch }) => {
        customer_address = JSON.parse(JSON.stringify(customer_address));
        delete customer_address['is_default'];
        const { data } = useFetch(route("endpoint.customeraddress.update", [customer_address.customer_address_id]), {
            beforeFetch: (ctx) => {
                let { cancel } = ctx;
                if(isLoading.value){
                    cancel();
                }
                NProgress.start();
                isLoading.value = true;
                ctx.options.headers = {
                    ...ctx.options.headers,
                    'Accept': 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Address updated successfully"
                });
                isLoading.value = false;
            },
            onFetchError: ()=>{
                isLoading.value = false;
            }
        })
            .put({
                customer_address
            })
            .json();
        return data;
    };

    const deleteAddress = (customer_address_id, { afterFetch }) => {
        const { data } = useFetch(route("endpoint.customeraddress.destroy", customer_address_id), {
            beforeFetch: (ctx) => {
                let { cancel } = ctx;
                if(isLoading.value){
                    cancel();
                }
                NProgress.start();
                isLoading.value = true;
                ctx.options.headers = {
                    ...ctx.options.headers,
                    'Accept': 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Address deleted successfully"
                });
                isLoading.value = false;
            },
            onFetchError: ()=>{
                isLoading.value = false;
            }
        }).delete().json();
        return data;
    };

    const setAddressToDefault = (customer_address, { afterFetch }) => {
        const { data } = useFetch(route("endpoint.customeraddress.setDefault", [customer_address.customer_address_id]), {
            beforeFetch: (ctx) => {
                let { cancel } = ctx;
                if(isLoading.value){
                    cancel();
                }
                NProgress.start();
                isLoading.value = true;
                ctx.options.headers = {
                    ...ctx.options.headers,
                    'Accept': 'application/json',
                }
                return ctx;
            },
            afterFetch: async (ctx) => {
                if (afterFetch && typeof afterFetch === "function") {
                    await afterFetch(ctx);
                }
                if (NProgress.isStarted()) {
                    NProgress.done();
                }
                setNotificationMessage({
                    type: "success",
                    message: "Address updated successfully"
                });
                isLoading.value = false;
            },
            onFetchError: ()=>{
                isLoading.value = false;
            }
        })
            .post()
            .json();
        return data;
    };
    return {
        createAddress,
        updateAddress,
        deleteAddress,
        setAddressToDefault,
    }
}